/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type GetAIConfigTargetingRequest = {
  projectKey: string;
  configKey: string;
};

/** @internal */
export const GetAIConfigTargetingRequest$inboundSchema: z.ZodType<
  GetAIConfigTargetingRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  projectKey: z.string(),
  configKey: z.string(),
});
/** @internal */
export type GetAIConfigTargetingRequest$Outbound = {
  projectKey: string;
  configKey: string;
};

/** @internal */
export const GetAIConfigTargetingRequest$outboundSchema: z.ZodType<
  GetAIConfigTargetingRequest$Outbound,
  z.ZodTypeDef,
  GetAIConfigTargetingRequest
> = z.object({
  projectKey: z.string(),
  configKey: z.string(),
});

export function getAIConfigTargetingRequestToJSON(
  getAIConfigTargetingRequest: GetAIConfigTargetingRequest,
): string {
  return JSON.stringify(
    GetAIConfigTargetingRequest$outboundSchema.parse(
      getAIConfigTargetingRequest,
    ),
  );
}
export function getAIConfigTargetingRequestFromJSON(
  jsonString: string,
): SafeParseResult<GetAIConfigTargetingRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => GetAIConfigTargetingRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'GetAIConfigTargetingRequest' from JSON`,
  );
}
